exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-radio {\n  display: block;\n  height: 4.4rem;\n  width: 4.4rem;\n  border: 1px solid #fff;\n  border-radius: 2.2rem;\n}\n\n.w-radio input {\n  display: none;\n}\n\n.w-radio.w-radio--checked {\n  background-color: #839AA7;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.w-radio.w-radio--checked:before {\n  content: \"\\E937\";\n  font-family: 'Icons';\n  font-size: 1.8rem;\n  color: #FFFFFF;\n}\n\n.w-radio.w-radio--dark {\n  border: 1px solid #0d3a52;\n}\n\n", ""]);

// exports
